import React, { useState, useEffect, useContext } from 'react';
import { Modal, Form, Input, Upload, Button, Space, Select, Spin, Checkbox, Divider, Row, Col, Radio, Progress } from 'antd';
import { InboxOutlined, VideoCameraOutlined, TagsOutlined, FileTextOutlined, UserOutlined } from '@ant-design/icons';
import { ModalWrapper } from './styled';
import { notify } from '../../../../utils/helper';
import { icdCodes } from '../../../../utils/icdCodes';
import { CPTCodes } from '../../../../utils/cptCodes';
import styled from 'styled-components';
import { physicianService } from '../../../../services/user';
import { io } from 'socket.io-client';
import { domain } from '../../../../utils/domainUrls';
import { extractToken } from '../../../../utils/localStorage';
import VideosPlayer from '../../videos_container/VideosPlayer';
import { SpecilityContext } from '../../../../context/SpecilityContext';
import { CPTCodesContext } from '../../../../context/CPTCodesContext';
import { ICDCodesContext } from '../../../../context/ICDCodesContext';

const { Dragger } = Upload;
const { Option } = Select;

const RadioButtonGroup = styled(Radio.Group)`

.ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper:first-child {
    border-right-color: transparent !important;
}

  .ant-radio-button-wrapper {
    height: 40px;
    line-height: 38px;
    padding: 0 24px;
    font-weight: 500;
    color: var(--primary-text-color);
    border-color: var(--border-color);
    background: var(--primary-bg);
    
    &:first-child {
      border-radius: 6px 0 0 6px;
    }
    
    &:last-child {
      border-radius: 0 6px 6px 0;
    }
    
    &.ant-radio-button-wrapper-checked {
      background: #8a3ef4;
      border-color: #8a3ef4;
      color: white !important;
      box-shadow: none;
      
      &:hover {
        color: white;
      }
    }
    
    &:hover {
      color: #8a3ef4;
    }
  }
`;

const UploadVideoModal = ({ isVisible, onCancel, onSubmit, isEdit, setIsEdit, selectedVideoUrl }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [fetchingPhysicians, setFetchingPhysicians] = useState(false);
  const [physicians, setPhysicians] = useState([]);
  const [isGeneralVideo, setIsGeneralVideo] = useState(false); // Add state to track general video
  const [progress, setProgress] = useState(0)
  const [uploadVisible, setUploadVisible] = useState(true);
  const [videoType, setVideoType] = useState("master");
  const { specialtyOptions } = useContext(SpecilityContext);
  const { cptOptions } = useContext(CPTCodesContext);
  const [fileList, setFileList] = useState([]); // <-- Add this line
  const { icdOptions } = useContext(ICDCodesContext);

  useEffect(() => {
  if(isEdit){
    setUploadVisible(false);
  }
  if(isEdit){
    if(selectedVideoUrl?.generalLibrary){
      setIsGeneralVideo(true);
      setVideoType('master')
      form.setFieldsValue({
        videoType: 'master'
      });
    } else {
      setIsGeneralVideo(false);
    }
    setVideoType(selectedVideoUrl?.referenceMasterVideoId ? "clone" : 'master')
    form.setFieldsValue({
      videoType: selectedVideoUrl?.referenceMasterVideoId ? "clone" : 'master'
    });

    if (selectedVideoUrl.videoType === "ccm") {
      setVideoType("ccm")
      form.setFieldsValue({
        videoType: selectedVideoUrl?.videoType
      });
    }

  }
  }, [selectedVideoUrl])


  const handleSubmit = async (values) => {    
    setLoading(true);
    try {
      const body = {
        ...values,
        isGeneralVideo: isGeneralVideo,
        
      }
      const modalBody = document.querySelector('.ant-modal-body');
      if (modalBody) {
        modalBody.scrollTo({ top: 0, behavior: 'smooth' });
      }
      await onSubmit(body,setProgress, isEdit, selectedVideoUrl?.key);
      form.resetFields();
      setIsGeneralVideo(true); 
      setUploadVisible(true);
      setIsEdit(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setIsGeneralVideo(true);
    setIsEdit(false)
    setUploadVisible(true)
    onCancel();
  };



  const fetchPhysicians = async () => {
    try {
      setFetchingPhysicians(true);
      const response = await physicianService.getAll(0,1,"","","");
      setPhysicians(response?.data?.results || []);
    } catch (error) {
      notify('error', 'Failed to fetch physicians');
    } finally {
      setFetchingPhysicians(false);
    }
  };

  useEffect(() => {
    if (isVisible) {
      fetchPhysicians();
    }
  }, [isVisible]);

  // const physicianOptions = physicians.map(physician => ({
  //   value: physician.id,
  //   label: `Dr. ${physician.name} - ${physician.specialty}`,
  //   name: physician.name,
  //   specialty: physician.specialty
  // }));

  const user = extractToken()
  // console.log("userdata:", user)

  useEffect(() => {
    const socket = io(domain);
    try {
      socket.on(`${user?.sub?.toString()}_upload`, (payload) => {

        setProgress(payload?.percentage);
      });
    } catch (err) {
    }
  }, []);

  useEffect(() => {
    const videoTitle = selectedVideoUrl?.title?.props?.children?.props?.children[0].props.children
    if (isEdit) {
      form.setFieldsValue({
        title: videoTitle || "",
        description: selectedVideoUrl?.description || "",
        specialty: selectedVideoUrl?.specialty?.props?.children || "",
        isGeneralVideo: !selectedVideoUrl?.generalLibrary ? false : true || "",
        physician: !selectedVideoUrl?.generalLibrary &&
        selectedVideoUrl?.physician !== "Not Assigned"
        ? selectedVideoUrl?.physician.map((item) => item?.id)
        : undefined || undefined,
        ...(selectedVideoUrl?.videoType === 'ccm' 
          ? { icdCodes: selectedVideoUrl?.tags || "" } 
          : { cptCodes: selectedVideoUrl?.tags || "" }
        ),
        customTags: selectedVideoUrl?.customTags || "",
        videoFile: selectedVideoUrl?.title?.props?.children?.props?.children[0].props.children || ""
      });
    } else {
      form.setFieldsValue({
        title: "",
        description: "",
        specialty: undefined,
        isGeneralVideo: true,
        physician: undefined,
        cptCodes: [],
        customTags: []
      });
    }
  }, [selectedVideoUrl, form, isEdit]);
  

  return (
    <ModalWrapper
      title={
      isEdit ? (
        <div className="flex items-center gap-2">
          {/* <VideoCameraOutlined className="text-primary" /> */}
          <h3 className="font-18 font-semibold text-primary mb-0">
            Update Video
          </h3>
          {progress?<Progress percent={progress}/> : ""}

        </div>
      ) : (
        <div className="flex items-center gap-2">
          {/* <VideoCameraOutlined className="text-primary" /> */}
          <h3 className="font-18 font-semibold text-primary mb-0">
            Upload Video
          </h3>
          {progress?<Progress percent={progress}/> : ""}

        </div>
      )
      }
      open={isVisible}
      onCancel={handleCancel}
      footer={null}
      width={700}
    >
      <Spin spinning={loading} tip="Uploading video...">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          disabled={loading}
          className="upload-video-form"
          onValuesChange={(changedValues, allValues) => {
            if (changedValues.videoType === "ccm") {
              form.setFieldsValue({
                specialty: "CCM - Chronic Care Management",
                isGeneralVideo: false,
              });
              setIsGeneralVideo(false);
            }
            if (changedValues.videoType && changedValues.videoType !== "ccm") {
              form.setFieldsValue({ specialty: "" });
            }
            if(changedValues.specialty === "Patient Education"){
              form.setFieldsValue({
                isGeneralVideo: true,
              });
              setIsGeneralVideo(true);
            }
            if(changedValues.specialty !== "Patient Education" && changedValues.specialty){
              form.setFieldsValue({
                isGeneralVideo: false,
              });
              setIsGeneralVideo(false);
            }
          }}
        >
          {/* Basic Information Section */}
          <div className="form-section">
            <div className="section-header">
              <FileTextOutlined className="section-icon" />
              <span className="section-title">Basic Information</span>
            </div>
            
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="title"
                  label="Video Title"
                  rules={[{ required: true, message: 'Please enter the video title' }]}
                >
                  <Input 
                    placeholder="Enter a descriptive title for your video" 
                    size="large"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={!isGeneralVideo ? 8 : 12} style={{ display: videoType === "ccm" ? "none" : undefined }}>
                <Form.Item
                  name="specialty"
                  label="Medical Specialty"
                  rules={[{ required: true, message: "Please select a specialty!" }]}
                  getValueProps={(val) => ({ value: val || undefined })}
                >
                  <Select
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Select medical specialty"
                    showSearch
                    style={{ width: '100%' }}
                    dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                    listHeight={160}
                    size="large"
                    options={[{label: "Patient Education", value: "Patient Education"}, ...specialtyOptions]}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    defaultValue={undefined}
                    value={form.getFieldValue('specialty')}
                  />
                </Form.Item>
              </Col>
             
              {!isGeneralVideo &&  (      
              <Col span={12}>
                <Form.Item
                  name="videoType"
                  label="Video Type"
                  initialValue={"master"}
                  rules={[{ required: true, message: 'Please select an option' }]}
                >
                  <RadioButtonGroup 
                    value={videoType}
                    onChange={(e) => {
                      const value = e.target.value;
                      setVideoType(value);
                      form.setFieldsValue({ videoType: value });
                      if (value === "ccm") {
                        form.setFieldsValue({ specialty: "CCM - Chronic Care Management", isGeneralVideo: false });
                        setIsGeneralVideo(false);
                      } else {
                        form.setFieldsValue({ specialty: "" });
                      }
                    }}
                  >
                    <Radio.Button value={"master"}>Master</Radio.Button>
                    <Radio.Button value={"clone"}>AI Enhanced</Radio.Button>
                    <Radio.Button value={"ccm"}>CCM</Radio.Button>
                  </RadioButtonGroup>
                </Form.Item>
              </Col>
              )}
            </Row>

            {videoType === "clone" && !isGeneralVideo && (
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="physician"
                    label="Assign to Physician"
                    rules={[{ required: true, message: 'Please select a physician' }]}
                  >
                    <Select
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      placeholder="Search and select a physician"
                      showSearch
                      size="large"
                      loading={fetchingPhysicians}
                      // options={physicianOptions}
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase()) ||
                        (option?.name ?? '').toLowerCase().includes(input.toLowerCase()) ||
                        (option?.specialty ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      notFoundContent={fetchingPhysicians ? <Spin size="small" /> : 'No physicians found'}
                      suffixIcon={fetchingPhysicians ? <Spin size="small" /> : <UserOutlined />}
                    >
                      {physicians.map((physician) => (
                        <Option
                          key={physician.id}
                          label={`${physician.name} : ${physician?.specialty} - ${physician?.email}`}
                          value={physician.id}
                          style={{borderBottom: "1px solid var(--border-color)"}}
                        >
                          {physician.name} : {physician?.specialty} - {physician?.email}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            
            <Form.Item
              name="description"
              label="Description"
              rules={[{ required: true, message: 'Please enter the video description' }]}
            >
              <Input.TextArea
                placeholder="Provide a detailed description of the video content, learning objectives, and target audience"
                rows={4}
                size="large"
              />
            </Form.Item>
          </div>

          <Divider className="section-divider" />

          {/* Tags and Classification Section */}
          <div className="form-section">
            <div className="section-header">
              <TagsOutlined className="section-icon" />
              <span className="section-title">Tags & Classification</span>
            </div>

            <Row gutter={16}>
              {videoType === "ccm" ? (
                <Col span={12}>
                  <Form.Item
                    name="icdCodes"
                    label="ICD Codes"
                    tooltip="Select relevant ICD codes for this video"
                  >
                    <Select
                      mode="tags"
                      // maxTagCount="responsive"
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      placeholder="Select or search ICD codes"
                      showSearch
                      size="large"
                      options={icdOptions}

                      filterOption={(input, option) =>
                        (option?.label?? '').toLowerCase().includes(input.toLowerCase()) 
                      }
                    />
                  </Form.Item>
                </Col>
              ) : (
                <Col span={12}>
                  <Form.Item
                  name="cptCodes"
                  label="CPT Codes"
                  tooltip="Select relevant CPT codes for this video"
                >
                  <Select
                    mode="tags"
                    // maxTagCount="responsive"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Select or search CPT codes"
                    showSearch
                    size="large"
                    options={cptOptions}

                    filterOption={(input, option) =>
                      (option?.label?? '').toLowerCase().includes(input.toLowerCase()) 
                    }
                  />
                  </Form.Item>
                </Col>
              )}
              <Col span={12}>
                <Form.Item
                  name="customTags"
                  label="Tags"
                  tooltip="Add custom tags to help categorize this video"
                >
                  <Select
                    mode="tags"
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    placeholder="Add custom tags (press Enter to add)"
                    size="large"
                    tokenSeparators={[',']}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>

          <Divider className="section-divider" />

          {/* File Upload Section */}
          <div className="form-section">
            <div className="section-header d-flex" style={{justifyContent: "space-between"}}>
              <div>
              <VideoCameraOutlined className="section-icon" />
              <span className="section-title">Video File</span>
              </div>
            {isEdit && (
              <div 
                className="cursor font-semibold"
                onClick={()=> setUploadVisible(!uploadVisible)}
                style={{
                  border: "1px solid var(--border-color)",
                  borderRadius: "5px",
                  padding: "2px 8px",
                  background: "#8a3ef4",
                  color: "#fff",
                }}
              >
                {uploadVisible ? "Cancel" : "Replace Video"}
              </div>
            )}
            </div>

            <Form.Item
              name="videoFile"
              rules={[{ required: true, message: 'Please upload a video file' }]}
            >
            {(uploadVisible) ? (
              <Dragger
                accept="video/*"
                multiple={false} 
                fileList={fileList}
                onChange={({ file, fileList: newFileList }) => {
                  // Keep only the latest file, replacing any previous selection
                  if (newFileList.length > 0) {
                    const latestFile = newFileList[newFileList.length - 1];
                    if (latestFile.size <= 500 * 1024 * 1024) {
                      setFileList([latestFile]);
                      form.setFieldsValue({ videoFile: latestFile });
                    } else {
                      // File is too large, don't add it
                      setFileList([]);
                      form.setFieldsValue({ videoFile: undefined });
                    }
                  } else {
                    // No file selected
                    setFileList([]);
                    form.setFieldsValue({ videoFile: undefined });
                  }
                }}
                beforeUpload={(file) => {
                  const maxSize = 500 * 1024 * 1024; // 500 MB
                  if (file.size > maxSize) {
                    notify('error', 'File size exceeds 500 MB. Please select a smaller file.');
                    return false;
                  }
                  return false; // Prevent auto upload
                }}
                disabled={loading}
                className="video-upload-dragger"
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
                </p>
                <p className="ant-upload-text">
                  <strong>Click or drag video file to this area to upload</strong>
                </p>
                <p className="ant-upload-hint">
                  Supports: MP4, AVI, MOV, WMV formats. Maximum file size: 500MB
                </p>
              </Dragger>
            ): (
              <VideosPlayer
                videoUrl={selectedVideoUrl?.videoUrl}
                title={selectedVideoUrl?.title?.props?.children?.props?.children[0].props.children}
              />
            )}
            </Form.Item>
          </div>

          {/* Action Buttons */}
          <Form.Item className="form-actions">
            <Space size="middle" style={{ width: '100%', justifyContent: 'flex-end' }}>
              <Button 
                className='modal-button'
                onClick={handleCancel}
                disabled={loading}
                size="large"
              >
                Cancel
              </Button>
              <Button 
                className='modal-button' 
                type="primary" 
                htmlType="submit"
                loading={loading}
                size="large"
                icon={<VideoCameraOutlined style={{color: "#fff"}} />}
              >
                {isEdit ? "Update Video" : "Upload Video"}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Spin>

      {/* Custom Styles */}
      <style jsx>{`
        .upload-video-form {
          padding: 8px 0;
        }

        .form-section {
          margin-bottom: 24px;
        }

        .section-header {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          padding-bottom: 8px;
          border-bottom: 1px solid var(--border-color);
        }

        .section-icon {
          font-size: 16px;
          color: #1890ff;
          margin-right: 8px;
        }

        .section-title {
          font-size: 16px;
          font-weight: 600;
          color: var(--primary-text-color);
        }

        .section-divider {
          margin: 32px 0 24px 0;
          border-top: 1px solid var(--border-color);
        }

        .general-video-checkbox {
          font-size: 14px;
        }

        .checkbox-label {
          font-weight: 500;
          color: #595959;
        }

        .video-upload-dragger {
          background: #fafafa;
          border: 2px dashed #d9d9d9;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .video-upload-dragger:hover {
          border-color: #40a9ff;
          background: #f6ffff;
        }

        .form-actions {
          margin-top: 32px;
          margin-bottom: 0;
          padding-top: 16px;
          border-top: 1px solid #f0f0f0;
        }

        .ant-form-item-label > label {
          font-weight: 500;
          color: #262626;
        }

        .ant-upload-text {
          font-size: 16px;
          margin-top: 16px;
        }

        .ant-upload-hint {
          color: var(--secondary-text-color) !important;
          font-size: 14px;
        }
        .ant-upload-list-item {
          background-color: var(--border-color);
          border-radius: 2px;
        }
        .ant-upload-list-item:hover  .ant-upload-list-item-info {
          background-color: var(--border-color) !important;
        }
        .ant-upload-list, .ant-upload-list-item-info .ant-upload-text-icon .anticon {
          color: var(--primary-text-color);
        }
        .ant-upload-list-item-card-actions:hover .anticon {
          color: var(--primary-text-color) !important;
        }
      `}</style>
    </ModalWrapper>
  );
};

export default UploadVideoModal;